import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-input-label',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './input-label.component.html',
    styleUrl: './input-label.component.css'
})
export class InputLabelComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() disableFields: any;
  @Input() autoFocused: any;
  @Input() labelAbove: any;
  @Input() allColsTextarea: any;
  @Input() twoGridColumn: any;

  formatDisplayName(value: string): string {
    if (!value) return '';

    const uppercaseWords = ['api', 'url', 'id', 'ip', 'dns', 'sso', 'saml', 'oauth', 'tls', 'ssl'];
    const originalWords = value.split(' ');

    return value
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        const originalWord = originalWords[index];
        if (originalWord && originalWord === originalWord.toUpperCase() && isNaN(Number(originalWord))) {
          return originalWord;
        }
        const cleanWord = word.replace(/[^a-z0-9]/g, '');
        if (uppercaseWords.includes(cleanWord)) {
          return word.toUpperCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  getDisplayValue(value: any): string {
    if (value && typeof value === 'object') {
      if (Array.isArray(value)) {
        return value.map(v => this.getDisplayValue(v)).join(', ');
      }
      return value.name || value.departmentName || value.title || value.label || JSON.stringify(value);
    }
    return value !== undefined && value !== null ? String(value) : '';
  }
}
